// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bullet[data-v-39baec76] {\n  display: inline-block;\n}[dir] .bullet[data-v-39baec76] {\n  border-radius: 50%;\n}\n.bullet.bullet-sm[data-v-39baec76] {\n  width: 10px;\n  height: 10px;\n}\n[dir] .bullet.bullet-primary[data-v-39baec76] {\n  background: var(--primary, #8bb2db);\n}\n[dir] .bullet.bullet-warning[data-v-39baec76] {\n  background: #ff9f43;\n}\n[dir] .bullet.bullet-danger[data-v-39baec76] {\n  background: #ea5455;\n}", ""]);
// Exports
module.exports = exports;
